import React from "react";
import { Tabs as MuiTabs, Tab as MuiTab, MuiThemeProvider } from "@material-ui/core";
import { useNavigate } from "../../hooks/useNavigate";
import { complaintsTheme } from "../ComplaintsModuleTheme";
import { withRouter } from "react-router-dom";
const _Tabs = ({ activeTabValue: activeTabId, tabs, match }) => {
    var _a;
    const navigate = useNavigate();
    const { url, params } = match;
    // the route match that sends us here should have an optional param at the end which represents the tab id e.g. "/my-page/:tabId?"
    const { tabId } = params;
    const resolvedActiveTabId = activeTabId || "";
    const tabActions = (_a = tabs.find(tab => tab.tabId === resolvedActiveTabId)) === null || _a === void 0 ? void 0 : _a.actions;
    return (React.createElement(MuiThemeProvider, { theme: complaintsTheme },
        React.createElement("div", { className: "CaseTabs" },
            React.createElement("div", { className: "CaseTabActions" }, tabActions),
            React.createElement(MuiTabs, { value: resolvedActiveTabId, indicatorColor: "primary", textColor: "primary", onChange: (_, destinationTabId) => {
                    const rootUrl = tabId === undefined
                        ? url // if we are on the root tab then the url is the root
                        : url.substring(0, url.length - tabId.length - 1); // otherwise get the root from taking the tabId away from the url
                    // if we are navigating to a tab (destinationTabId is something) then add it to the root
                    //  otherwise just go to the root (destinationTabId is empty)
                    const destination = destinationTabId ? `${rootUrl}/${destinationTabId}` : rootUrl;
                    navigate(destination);
                } }, tabs.map(({ tabId, label }) => (React.createElement(MuiTab, { key: tabId, value: tabId, label: label, "data-test": "tab-" + tabId, style: { textTransform: "none" } })))))));
};
export const Tabs = withRouter(_Tabs);
